import { useMemo, useState } from 'react';
import products from '../data/sectorMappings.json';
import './SectorMappingExplorer.css';

type View = 'group78' | 'eora23';
const labels = { group78: 'EXIO 200 → 78', eora23: 'EXIO 200 → Eora 23' };
export default function SectorMappingExplorer() {
  const [view, setView] = useState<View>('group78');
  const [group, setGroup] = useState('');
  const [product, setProduct] = useState('');
  const groups = useMemo(() => {
    const result = new Map<string, { code: string; name: string; count: number }>();
    products.forEach(p => { const t = p[view]; const existing = result.get(t.code);
      result.set(t.code, { ...t, count: (existing?.count || 0) + 1 }); });
    return Array.from(result.values()).sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));
  }, [view]);
  const members = products.filter(p => !group || p[view].code === group);
  const selected = products.find(p => p.code === product);
  const activeGroup = groups.find(g => g.code === group);
  const maxCount = Math.max(...groups.map(g => g.count));
  return <section id="sector-mappings" className="sector-mappings" aria-label="Sector mappings">
    <div className="mapping-toolbar" role="group" aria-label="Mapping view">
      <span>Mapping view</span>
      {(Object.entries(labels) as [View, string][]).map(([key, label]) =>
        <button type="button" key={key} aria-pressed={view === key} onClick={() => {
          setView(key); setGroup(''); setProduct('');
        }}>{label}</button>)}
    </div>
    <div className="mapping-columns">
      <div className="mapping-groups">
        <h3>Target groups <span>({groups.length})</span></h3>
        <button type="button" className="mapping-all" aria-pressed={!group} onClick={() => { setGroup(''); setProduct(''); }}>All groups</button>
        <div className="mapping-scroll" aria-label="Target groups">
          {groups.map(g => <button type="button" key={g.code} className="mapping-group" aria-pressed={group === g.code}
            onClick={() => { setGroup(g.code); setProduct(''); }}>
            <span className="mapping-group-label"><span>{g.code} · {g.name}</span><span>{g.count} {g.count === 1 ? 'product' : 'products'}</span></span>
            <span className="mapping-bar" aria-hidden="true"><span style={{ width: `${100 * g.count / maxCount}%` }} /></span>
          </button>)}
        </div>
      </div>
      <div className="mapping-members">
        <h3>{activeGroup ? `${activeGroup.code} · ${activeGroup.name}` : 'EXIO products'}</h3>
        <p role="status" className="mapping-caption">{members.length} matching {members.length === 1 ? 'product' : 'products'}</p>
        {selected && <aside className="mapping-detail" aria-label="Product assignments">
          <h3>{selected.code} · {selected.name}</h3>
          <dl><dt>EXIO 200 → 78</dt><dd>{selected.group78.code} · {selected.group78.name}</dd>
            <dt>EXIO 200 → Eora 23</dt><dd>{selected.eora23.code} · {selected.eora23.name}</dd></dl>
          <button type="button" onClick={() => setProduct('')}>Close product details</button>
        </aside>}
        <div className="mapping-scroll">
          {members.length ? <ul className="mapping-products">{members.map(p => <li key={p.code}>
            <button type="button" aria-pressed={product === p.code} onClick={() => setProduct(p.code)}>
              <span className="mapping-code">{p.code}</span><span>{p.name}</span>
            </button>
          </li>)}</ul> : <p>No products in this group. <button type="button" onClick={() => setGroup('')}>All groups</button></p>}
        </div>
      </div>
    </div>
    <p className="mapping-caption">These classifications describe product assignments. They do not change the calibrated datasets or simulation results.</p>
  </section>;
}
